import type { ResourceBlock, ResourceSection } from '@root/@types/base';
import { BlockError } from '@root/@types/types';

export const isBlockValid = ({ validationErrors = [] }: ResourceBlock): boolean =>
  validationErrors.filter((error) => error !== BlockError.UnresolvedComments).length === 0;
export const areSectionBlocksValid = ({ blocks = [] }: ResourceSection): boolean => blocks.every(isBlockValid);
